import classNames from "classnames";
import { ENABLE_SYNC_UNIT_CONTROLLER } from "../constants/constants";
import useNavigation from "../hooks/use-navigation";

import ImageShow from "../components/ImageShow";

function Link({
  to,
  children,
  className,
  activeClassName,
  icon,
  iconClass,
  handleClick,
  broker,
  size,
  iconSize,
  ...rest
}) {
  const { navigate, currentPath } = useNavigation();
  // SCR-01..03: «Рахунки» leads to /unified-upload or to /reports and is active on all of them.
  const onUnifiedUpload = currentPath === "/unified-upload" || currentPath?.startsWith("/unified-upload/");
  const classes = classNames(
    "",
    className,
    currentPath === to && activeClassName,
    currentPath === "/accounts" && to === "/reports" && activeClassName,
    currentPath === "/upload" && to === "/reports" && activeClassName,
    currentPath === "/upload" && to === "/accounts" && activeClassName,
    currentPath === "/autosync" && to === "/accounts" && activeClassName,
    currentPath === "/reports" && to === "/accounts" && activeClassName,
    currentPath === "/declaration" && to === "/taxreports" && activeClassName,
    currentPath === "/referral-info" && to === "/referral" && activeClassName,
    onUnifiedUpload && to === "/unified-upload" && activeClassName,
    // Without the sync unit flag «Рахунки» may lead to /reports; with it /reports is «Мої рахунки» (SCR-04).
    onUnifiedUpload && to === "/reports" && !ENABLE_SYNC_UNIT_CONTROLLER && activeClassName,
    currentPath?.startsWith("/sync/") && to === "/sync" && activeClassName,
    currentPath?.startsWith("/accounts/") && to === "/reports" && activeClassName
  );

  if (!handleClick) {
    handleClick = (event) => {
      if (event.metaKey || event.ctrlKey) {
        return;
      }
      event.preventDefault();

      navigate(to);
    };
  }

  return (
    <a
      className={classes}
      href={to}
      onClick={handleClick}
      broker={broker}
      {...rest}>
      {icon && (
        <ImageShow
          className={iconClass}
          image={{ url: icon, label: children }}
          size={iconSize || 20}
        />
      )}
      {children}
    </a>
  );
}

export default Link;
